import { __extends } from "tslib";
import { StartLabelDetectionRequest, StartLabelDetectionResponse } from "../models/models_0";
import { deserializeAws_json1_1StartLabelDetectionCommand, serializeAws_json1_1StartLabelDetectionCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartLabelDetectionCommand = /** @class */ (function (_super) {
    __extends(StartLabelDetectionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartLabelDetectionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartLabelDetectionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "RekognitionClient";
        var commandName = "StartLabelDetectionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: StartLabelDetectionRequest.filterSensitiveLog,
            outputFilterSensitiveLog: StartLabelDetectionResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartLabelDetectionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StartLabelDetectionCommand(input, context);
    };
    StartLabelDetectionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StartLabelDetectionCommand(output, context);
    };
    return StartLabelDetectionCommand;
}($Command));
export { StartLabelDetectionCommand };
//# sourceMappingURL=StartLabelDetectionCommand.js.map